import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import InputComponent from '../../Components/Common/InputComponent';
import { goalvalidationSchema } from './utils';

const AddGoalModal = ({ onCloseClick, show, goalFormObj, editGoalObj, handleSucess, rawData, treeList, load }) => {
    const handleSave = (data) => {
        // When Editing Goal
        if (editGoalObj) {
            let { goal, id, uniquelink } = editGoalObj;

            const goalIsAvailabel = treeList?.find((i) => i?.goal?.toLocaleLowerCase() === data.goal?.toLocaleLowerCase());
            if (goalIsAvailabel) {
                toast.error('Goal is already  available.');
                return;
            }
            const result = [...treeList]?.map((i) => {
                if (i?.goal?.toLocaleLowerCase() === goal?.toLocaleLowerCase() && id === i?.goalId) {
                    return { ...i, goal: data.goal };
                }
                return { ...i };
            });

            const groupedByCategory = result?.reduce((res, item) => {
                const category = item.categoryId + '-' + item.subCategoryId + '-' + item?.needType;
                if (!res[category]) {
                    res[category] = [];
                }
                res[category].push(item);
                return res;
            }, {});

            let finalValue = Object.keys(groupedByCategory)?.map((item) => {
                let [catId, subCatId, needType] = item?.split('-');

                return {
                    needCategoryIcd10Id: catId,
                    needSubCategoryIcd10Id: subCatId,
                    goals: groupedByCategory[item]?.map((e) => e.goal),
                    needType: Number(needType)
                };
            });

            let dataObj = {
                uniqueLink: uniquelink,
                needs: finalValue
            };

            handleSucess(dataObj);
        } else {
            const goalIsAvailabel = treeList?.find((i) => i?.goal?.toLocaleLowerCase() === data.goal?.toLocaleLowerCase());
            if (goalIsAvailabel) {
                toast.error('Goal is already  available in needs.');
                return;
            }
            // When Adding Goal
            handleSucess(data);
        }
    };
    return (
        <Modal isOpen={show} toggle={onCloseClick} size="md" centered={true}>
            <ModalHeader className="bg-soft-primary">{editGoalObj ? 'Edit Goal' : 'Add Goal'}</ModalHeader>
            <ModalBody className="px-5 py-3">
                <Formik
                    initialValues={goalFormObj}
                    validationSchema={goalvalidationSchema}
                    onSubmit={(values) => {
                        handleSave(values);
                    }}
                >
                    {({ setFieldValue, values, errors, handleSubmit, touched, handleBlur }) => (
                        <>
                            <Row>
                                <InputComponent
                                    type="text"
                                    name="goal"
                                    id="goal"
                                    className="input-default"
                                    placeholder={'Enter goal'}
                                    invalid={!!errors?.goal && touched.goal}
                                    onChange={(e) => setFieldValue('goal', e.target.value)}
                                    onBlur={(e) => setFieldValue('goal', e.target.value?.trim())}
                                    validations={['required']}
                                    title={values?.goal}
                                    value={values?.goal}
                                />
                            </Row>
                            <div className="mt-4 float-right  d-flex">
                                <button
                                    type="button"
                                    className="btn btn-md btn-primary "
                                    data-bs-dismiss="modal"
                                    onClick={handleSubmit}
                                    disabled={load}
                                    id="goalSave"
                                >
                                    {load ? 'Loading' : 'Save'}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-md ms-3 btn-outline-primary"
                                    id="goalCancel"
                                    onClick={onCloseClick}
                                >
                                    Cancel
                                </button>
                            </div>
                        </>
                    )}
                </Formik>
            </ModalBody>
        </Modal>
    );
};

export default AddGoalModal;
